export default __webpack_public_path__ + "static/4-dd73cb96a77a6ad29d1adce3c2fead59.jpeg";